/** The DropdownEvent is dispatched when the user selects or de-selects an item. */
export default class DropdownEvent extends Event {
	public static SELECTED_CHANGED = 'DropdownEvent.selectedChanged';
	/**
	 * Returns the value property in the DropdownItem that was provided as the Dropdown data property.
	 *
	 * If the user de-selects, this value will be null.
	 */
	public get value(): null | unknown {
		return this.#value;
	}

	#value: unknown;
	public constructor(value: null | unknown = null) {
		super(DropdownEvent.SELECTED_CHANGED, { bubbles: true });
		this.#value = value;
	}
}
